<template>
  <div id="ovens-slide-pins">
    <div class="ps-headers">
      <div class="ps-header-left font-responsive" :class="{ 'header--active': isStateActive('left') }" @click.prevent="changeActiveState('left')">
        <span class="sub-title">Nowa linia</span>
        <span class="title">Amica X-type</span>
      </div>
      <div class="ps-header-right font-responsive" :class="{ 'header--active': isStateActive('right') }" @click.prevent="changeActiveState('right')">
        <span class="sub-title">Nowa linia</span>
        <span class="title">Amica Q-type</span>
      </div>
    </div>
    <div class="ps-wrapper">
      <div class="ps-inner-wrapper" :class="getActiveState">
        <div class="ps-slide ps-slide--left" @click.prevent="changeActiveState('left')" :style="'background-image: url('+component_data.params.slides.left.background+');'">
          <template v-if="isStateActive('left')">
            <single-slide-pin v-for="pin in component_data.params.slides.left.pins" v-bind:key="pin.id" :params="pin" @closeAllPins="closeAllPins"></single-slide-pin>
          </template>
        </div>
        <div class="ps-slide ps-slide--right" @click.prevent="changeActiveState('right')" :style="'background-image: url('+component_data.params.slides.right.background+');'">
          <template v-if="isStateActive('right')">
            <single-slide-pin v-for="pin in component_data.params.slides.right.pins" v-bind:key="pin.id" :params="pin" @closeAllPins="closeAllPins"></single-slide-pin>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SingleSlidePin from '@/components/LpSections/SingleSlidePin'

export default {
  props: ['component_data'],
  data () {
    return {
      defaultState: true, // zadna strona nie jest aktywna,
      activeState: '', //empty, left, right
    }
  },
  computed: {
    getActiveState: function () {
      if (!this.defaultState) {
        return 'active-' + this.activeState
      }
      return ''
    }
  },
  methods: {
    changeActiveState: function (state) {
      this.defaultState = false
      this.activeState = state
    },
    isStateActive: function (state) {
      if (state == this.activeState) {
        return true
      }
    },
    closeAllPins: function () {
      Array.prototype.forEach.call(this.component_data.params.slides.left.pins, pin => {
        pin.visible = false
      })
      Array.prototype.forEach.call(this.component_data.params.slides.right.pins, pin => {
        pin.visible = false
      })
    }
  },
  components: {
    SingleSlidePin
  }
}
</script>

<style lang="scss" scoped>
  #ovens-slide-pins {
    overflow: hidden;
  }

  .ps-headers {
    width: calc((100vw / 12) * 8);
    margin-left: calc(((100vw / 12) * 2) + (100vw * .008));
    font-family: 'Uni Neue', sans-serif;
    margin-bottom: 30px;

    .ps-header-left {
      width: 50%;
      display: inline-block;
      opacity: .3;
      cursor: pointer;

      &.header--active {
        opacity: 1;
      }
    }

    .ps-header-right {
      width: 50%;
      display: inline-block;
      text-align: right;
      opacity: .3;
      cursor: pointer;
      
      &.header--active {
        opacity: 1;
      }
    }

    .sub-title {
      font-size: 2.8em;
      font-weight: 100;
      color: #e41429;
      display: inline-block;
      width: 100%;
    }

    .title {
      font-size: 4.2em;
      line-height: 30px;
      font-weight: 500;
      color: #e41429;
      display: inline-block;
      width: 100%;
    }
  }

  .ps-wrapper {
    width: 100vw;
    height: 34.375vw;
    margin-bottom: 40px;
    position: relative;

    .ps-inner-wrapper {
      position: relative;
      width: calc(100vw * 2 - ((100vw / 12) * 4));
      height: 100%;
      z-index: 99;

      -webkit-transform: translateX((100vw - ((100vw / 12) * 4)) * -.5); 
      -moz-transform: translateX((100vw - ((100vw / 12) * 4)) * -.5); 
      -ms-transform: translateX((100vw - ((100vw / 12) * 4)) * -.5); 
      -o-transform: translateX((100vw - ((100vw / 12) * 4)) * -.5); 
      transform: translateX((100vw - ((100vw / 12) * 4)) * -.5);

      -webkit-transition: transform .3s ease-in-out;
      -moz-transition: transform .3s ease-in-out;
      -o-transition: transform .3s ease-in-out;
      transition: transform .3s ease-in-out;

      &.active-left {
        transform: translateX(0);
      }

      &.active-right {
        transform: translateX((100vw - ((100vw / 12) * 20)));
      }

      .ps-slide {
        height: 100%;
        width: 49.5%;
        display: inline-block;
        cursor: pointer;
        position: relative;

        &.ps-slide--left {
          margin-right: .5%;
          background-position: top right;
          background-repeat: no-repeat;
          background-size: cover;
        }
        &.ps-slide--right {
          margin-left: .5%;
          background-position: top left;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }
  }
</style>
